import styled from "styled-components";

export const TaskImgBackModalLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;

  p {
    text-align: center;
    font-size: 1.4rem;
    font-weight: 500;
    white-space: pre-line;
    word-break: keep-all;
  }
`;

export const TaskImgBackModalButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  gap: 9px;

  .small {
    width: 40%;
  }
`;
